import type { TimestampedSystemMessage } from '../types/chat'

export interface PatContextMessageMetadata extends Record<string, unknown> {
  type: 'pat_context'
  targetCharacterId: string | 'self'
}

interface MessageWithPatMetadata {
  role?: unknown
  metadata?: unknown
}

export function isPatContextMessage(message: unknown): message is object & MessageWithPatMetadata {
  if (!message || typeof message !== 'object')
    return false

  const { role, metadata } = message as MessageWithPatMetadata
  if (role !== 'system' || !metadata || typeof metadata !== 'object')
    return false

  return (metadata as { type?: unknown }).type === 'pat_context'
}

export function collectPatContextMessages<T>(messages: readonly T[]): T[] {
  return messages.filter(isPatContextMessage)
}

export function removeConsumedPatContextMessages<T>(
  messages: readonly T[],
  consumedMessages: ReadonlySet<object>,
): T[] {
  return messages.filter(message => !(
    typeof message === 'object'
    && message !== null
    && consumedMessages.has(message)
    && isPatContextMessage(message)
  ))
}

export function createPatContextMessage(
  content: string,
  timestamp: number,
  targetCharacterId: string | 'self',
): TimestampedSystemMessage {
  return {
    role: 'system',
    content,
    timestamp,
    isHidden: true,
    metadata: {
      type: 'pat_context',
      targetCharacterId,
    } satisfies PatContextMessageMetadata,
  }
}
